import { mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { ScheduleIntervalAction } from '@cbridge-packages/schedule-interval';

export const reloadIntervalEpic: IEpic = (action$) => action$.pipe(
  isTypeOfAndGetPayload(ScheduleIntervalAction.update.done),
  mergeMap((payload) => {
    const { params: { scheduleId } } = payload;

    return [
      ScheduleIntervalAction.load.started({ scheduleId }),
    ];
  }),
);
